import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DPLogin from './Login';
import Rides from './Rides';
import RideDetails from './RideDetails';

function App() {
  return (

      <Routes>
        <Route path='/delivery' element={<DPLogin/>} />
        <Route path='/delivery/rides' element={<Rides/>} />
        <Route path='/delivery/ride-details' element={<RideDetails/>} />
      </Routes>
  );
}

export default App;
